import { useEffect } from "react";
import { SiteNav, SiteFooter } from "../components/SiteChrome";
import "../styles/site.css";

export default function Privacy() {
  useEffect(() => {
    document.title = "C-STYL — Privacy Policy";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="site" data-testid="privacy-page">
      <SiteNav />

      <div className="doc">
        <h1 className="serif">Privacy Policy</h1>
        <p style={{ color: "#8b857c" }}>Last updated: June 2026</p>
        <p>This Privacy Policy explains what information C-STYL (“we”, “us”) collects and how we use it. By using the app you agree to this policy.</p>

        <h2>Information we collect</h2>
        <ul>
          <li><b>Photos you add</b> — pictures of your clothing and, optionally, a full-body reference photo for virtual try-on. Stored securely and used only to provide the app’s features.</li>
          <li><b>Location</b> — your approximate or precise location is used to fetch local weather. You can use the app without location by setting a city manually.</li>
          <li><b>Account information</b> — if you create an account, your email address and an encrypted password. Guest use requires no account.</li>
          <li><b>Usage data</b> — the items, outfits and preferences you create in the app.</li>
        </ul>

        <h2>How we use your information</h2>
        <ul>
          <li>To organize your closet and auto-tag clothing.</li>
          <li>To generate weather-aware outfit recommendations.</li>
          <li>To create virtual try-on previews on your reference photo.</li>
          <li>To sync your data to your account (if you create one).</li>
        </ul>

        <h2>AI processing</h2>
        <p>To auto-tag clothing, generate outfit explanations, and create try-on previews, images and text are processed by trusted third-party AI providers solely to deliver these features. This content is not used to advertise to you.</p>

        <h2>Sharing</h2>
        <p>We do not sell your personal information. We share data only with service providers that help us run the app (secure image storage, weather, and AI processing), under agreements that limit their use of it.</p>

        <h2>Data retention &amp; deletion</h2>
        <p>Your data is kept while your account is active. You can permanently delete your account and all associated data at any time from <b>Profile → Delete account</b>, or by emailing us.</p>

        <h2>Security</h2>
        <p>We use industry-standard measures to protect your data, including encrypted passwords and secure image storage. No method of transmission or storage is 100% secure.</p>

        <h2>Children</h2>
        <p>C-STYL is not directed to children under 13, and we do not knowingly collect their data.</p>

        <h2>Contact</h2>
        <p>Questions? Email <a href="mailto:support@c-styl.com" style={{ color: "#C8A24C" }}>support@c-styl.com</a>.</p>
      </div>

      <SiteFooter />
    </div>
  );
}
